import React from 'react';

function Footer() {
  return (
    <footer className="copyright-footer footer-positioned">
      <p>© 2026 DHO Kotdwar. All Rights Reserved | Design by &nbsp;Brainrock</p>
    </footer>
  );
}

export default Footer;